const CURRENCY_SYMBOL_LOCAL_MAP: { [key: string]: string } = {
    us: '$', // 前面
    ca: '$', // 前
    uk: '£', // 前
    eu: '€', // 前
    de: '€', // 后
    fr: '€', // 后
    it: '€', // 后
    es: '€', // 后
    nl: '€', // 前  €1.799,00
    cis: '₽', // 后
    jp: '¥', // 前
    cn: '¥', // 前
    kr: '₩', // 前
    sa: 'د.إ', // 前
    za: 'R', // 前
    au: '$', // 前
    tw: 'NT$', // 前
    hk: 'HK$', //前
    br: 'R$', // 前
    mx: 'MXN ', // 前
    ph: '₱', // 前
};

export const i18nMap: Record<string, string> = {
    us: 'en-us',
    ca: 'en-ca',
    uk: 'en-uk',
    eu: 'en-eu',
    za: 'en-za',
    au: 'en-au',
    de: 'de-de',
    fr: 'fr-fr',
    es: 'es-es',
    it: 'it-it',
    jp: 'ja-jp',
    kr: 'ko-kr',
    cn: 'zh-cn',
    ru: 'ru-ru',
    cis: 'ru-ru',
    nl: 'nl-nl',
    tw: 'zh-tw',
};

// 货币符号位置在后的站点
const CURRENCY_SYMBOL_AFTER_SITES: string[] = ['de', 'fr', 'it', 'es', 'cis'];
// 千分位分隔符为英文句号的站点
const THOUSANDS_SEPARATOR_PERIOD_SITES: string[] = ['eu', 'it', 'es', 'nl'];
// 千分位分隔符为空格的站点
const THOUSANDS_SEPARATOR_SPACE_SITES: string[] = ['de', 'fr'];
// 小数点分割符为逗号的站点
const DECIMAL_SEPARATOR_COMMA_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es'];
// 货币符号与货币之间有空格的站点
const HAS_SPACE_BETWEEN_SITES: string[] = ['de', 'fr', 'it', 'za', 'mx', 'br'];

const _getCurrencySymbol = (locale: string) => {
    return CURRENCY_SYMBOL_LOCAL_MAP[locale] || CURRENCY_SYMBOL_LOCAL_MAP.us;
};

const _getThousandsSeparator = (locale: string) => {
    if (THOUSANDS_SEPARATOR_PERIOD_SITES.includes(locale)) {
        return '.';
    }
    if (THOUSANDS_SEPARATOR_SPACE_SITES.includes(locale)) {
        return '\u202F';
    }
    return ',';
};

const _getDecimalSeparator = (locale: string) => {
    if (DECIMAL_SEPARATOR_COMMA_SITES.includes(locale)) {
        return ',';
    }
    return '.';
};

const _getHasSpaceBetween = (locale: string) => {
    return HAS_SPACE_BETWEEN_SITES.includes(locale) ? ' ' : '';
};

/**
 * @param price 价格
 * @param locale
 * @returns str
 */
export const formatPrice = (price: string, locale: string): string => {
    const str = price ? String(price).replace('.00', '') : '0';
    let newStr = '';

    newStr = new Intl.NumberFormat(i18nMap[locale]).format(Number(str));

    if (isNaN(Number(str))) newStr = '0';
    if (locale === 'za') newStr = newStr.replace(/\W/g, ',');
    if (locale === 'de') newStr = `${newStr.replace(/\./g, ' ')} `;

    // 欧洲5国想要加空格
    if (['fr', 'de', 'es', 'it'].includes(locale)) return `${newStr} ${CURRENCY_SYMBOL_LOCAL_MAP[locale]}`;
    if (locale === 'eu') return `${CURRENCY_SYMBOL_LOCAL_MAP[locale]} ${newStr}`;
    return CURRENCY_SYMBOL_LOCAL_MAP[locale] + newStr;
};

const FormatCurrencyLocal = (value: number, locale: string, isShoppingCart?: boolean, customThousandsSeparator?: string) => {
    if (!value && value !== 0) return value;
    let strValue: string = value.toString();
    const currencySymbol = _getCurrencySymbol(locale);
    const thousandsSeparator = customThousandsSeparator ?? _getThousandsSeparator(locale);
    const decimalSeparator = _getDecimalSeparator(locale);
    const hasSpaceBetween = _getHasSpaceBetween(locale);

    if (DECIMAL_SEPARATOR_COMMA_SITES.includes(locale)) {
        strValue = strValue.replace('.', decimalSeparator);
    }
    const reg = /(\d)(?=(\d{3})+$)/g;
    strValue = strValue.replace(reg, `$1${thousandsSeparator}`);
    strValue = CURRENCY_SYMBOL_AFTER_SITES.includes(locale)
        ? `${strValue}${hasSpaceBetween}${currencySymbol}`
        : `${currencySymbol}${hasSpaceBetween}${strValue}`;
    // 购物车中的整数需要 加小数点后两位， 如果strValue已经是带了两位小数00时，如12.00，不需要加
    if (isShoppingCart && (value | 0) === value && !strValue.includes(decimalSeparator)) {
        strValue = `${strValue}${decimalSeparator}00`;
    }
    return strValue;
};

export default FormatCurrencyLocal;
